import _ from 'lodash';

// Canonical identity for registry and palette lookups: the last dotted segment
// with the runtime's "agent" wrapper stripped, kebab-cased — so 'autopilot-agent',
// 'autopilot.data-analyst', and 'Agent-dataAnalyst' all resolve to a stable key.
// The one implementation shared by ToolCallCard's delegation glyph and app-side
// agent registries.
export const canonicalAgentKey = key => {
  const cleaned = String(key || '')
    .split('.')
    .pop()
    .replace(/^agent[-_]/i, '')
    .replace(/[-_]agent$/i, '');
  return _.kebabCase(cleaned) || 'autopilot';
};
